/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Description_Export_Video_FailedInputs */

const en_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error exporting video: ${i?.error}`)
};

const fr_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'exportation vidéo : ${i?.error}`)
};

const de_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Videoexport: ${i?.error}`)
};

const it_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'esportazione del video: ${i?.error}`)
};

const ru_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка экспорта видео: ${i?.error}`)
};

const es_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al exportar el vídeo: ${i?.error}`)
};

const zh_cn2_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出视频时出错：${i?.error}`)
};

const ja_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポート中にエラーが発生しました: ${i?.error}`)
};

const hi_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो निर्यात करने में त्रुटि: ${i?.error}`)
};

const pt_pt2_audio_description_export_video_failed = /** @type {(inputs: Audio_Description_Export_Video_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao exportar o vídeo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error exporting video: {error}" |
*
* @param {Audio_Description_Export_Video_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_failed = /** @type {((inputs: Audio_Description_Export_Video_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_failed(inputs)
	if (locale === "de") return de_audio_description_export_video_failed(inputs)
	if (locale === "it") return it_audio_description_export_video_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_video_failed(inputs)
	if (locale === "es") return es_audio_description_export_video_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_video_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_video_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_failed(inputs)
	return en_audio_description_export_video_failed(inputs)
});